import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { getLocaleFolderForI18nextLanguage } from '@/utils/languageCodeUtils'

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: import.meta.env.VITE_ENVIRONMENT === 'development',
    fallbackLng: 'en',
    returnEmptyString: false,
    // Keep language codes and folder names in sync, especially for complex tags like 'fa-latn-ir'
    cleanCode: false,
    lowerCaseLng: true,
    backend: {
      // i18next lowercases locale codes when lowerCaseLng=true (e.g. ht_HT -> ht_ht).
      // Some of our locale folders use case/underscore that won't match the lowercased code.
      loadPath: (languages: string[] | string, namespaces: string[] | string) => {
        const lng = Array.isArray(languages) ? languages[0] : languages
        const ns = Array.isArray(namespaces) ? namespaces[0] : namespaces

        const folder = getLocaleFolderForI18nextLanguage(lng)
        return `/locales/${folder}/${ns}.json`
      },
    },
  })

export default i18n
